<template>
     <vs-dialog v-model="active" >
        <template #header>
          <h4 class="not-margin">
            Trasladar saldo
          </h4>
        </template>
        <div class="con-form">
          <div v-if="row && row.saldo || row && row.saldo_a_favor" class="text-center" style="border: 1px solid gray; border-radius: 7px">
            <p class="mb-0">Saldo a favor</p>
            <h4 class="mb-2"><strong>{{row.saldo ? row.saldo : row.saldo_a_favor | currency}}</strong></h4>
            <div v-for="(option, i) in cicloEscolares" :key="i">
              <p v-if="cicloEscolar == option.id">En el ciclo escolar <strong>{{option.text}}</strong></p>
            </div>
          </div>
          <form autocomplete="off">
              <h6 class="mb-2 mt-3"><strong>Trasladar saldo a</strong></h6>
              <vs-select v-if="ciclosEscolares.length" class="mr-0 pt-0" placeholder="Seleccionar Ciclo Escolar" filter v-model="cicloEscolarTranslado"  :key="cicloEscolarId" :disabled="!cicloEscolares.length">
                      <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id" :disabeld="option.id == cicloEscolar">
                          {{option.text}}
                      </vs-option>
              </vs-select>
              <p v-else>No hay ciclo escolar para transladar saldo</p>
          </form>
        </div>
        <template #footer>
          <div class="footer-dialog" style="display:flex;">  
            <vs-button block danger class="color-red">
              Cancelar
            </vs-button>
            <vs-button block success @click="getTransladarSaldos" v-if="ciclosEscolares.length">
              Aceptar
            </vs-button>          
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import profesor from '../../../../api/requests/landing-profesor.js'

export default {
    props:[
      'value',
      'row',
      'personaId',
      'institucion',
      'cicloEscolar',
      'cicloEscolares'
    ],
    data () {
        return {
            active: false,
            cicloEscolarTranslado: '',
            cicloEscolarId: (new Date()).getTime(),
            ciclosEscolares: [],
        }
    },
    methods: {
      nuevosCiclos() {
        this.ciclosEscolares = []
        this.cicloEscolares.forEach(element => {
          if(element.id > this.cicloEscolar){
            this.ciclosEscolares.push(element)
          }
        })
      },
      async getTransladarSaldos(){
        try{
          const params = {
            persona_id: this.personaId,
            institucion_id: this.institucion,
            ciclo_escolar_origen_id: this.cicloEscolar,
            ciclo_escolar_detino_id: this.cicloEscolarTranslado,
            monto: this.row.saldo ? this.row.saldo : this.row.saldo_a_favor
          }
          const response = await profesor.getTransladarSaldos(params)
          this.$vs.notification({
              progress: 'auto',                           
              color: 'success',
              position: null,
              title: 'Éxito',
              text: 'Se translado el saldo correctamente'
          })
          this.$emit('refreshTable')
          this.cicloEscolarTranslado = ''
          this.active = false
        }catch{
          this.$vs.notification({
              progress: 'auto',
              color: 'danger',
              position: null,
              title: 'Error',
              text: 'Favor de comunicarse con el administrador.'
          })
        }
      }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        row(){
          this.nuevosCiclos()
        }
    }
}
</script>
